// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("js/" + "actioncable" + "-" + "b6fddfcee0f92c1ab6dc" + ".chunk.js");